import React, {Dispatch, ReactNode, SetStateAction, useCallback} from 'react'
import {handleSortChange, Headers, SortKeys, SortOrder} from '../types'
import {SortButton} from './SortButton'

interface THeadInterface<T> {
    headers: Headers<T>[];
    sortKey: SortKeys<T>
    setSortKey: Dispatch<SetStateAction<SortKeys<T>>>;
    sortOrder: SortOrder;
    setSortOrder: Dispatch<SetStateAction<SortOrder>>;
    children?: ReactNode;
    firstChildren?: ReactNode;
}


const THead = <T, >({
                        headers,
                        sortKey,
                        sortOrder,
                        setSortOrder,
                        setSortKey,
                        children,
                        firstChildren,
                    }: THeadInterface<T>) => {

    const handleClick = useCallback((key: SortKeys<T>) => {

        handleSortChange({key, sortOrder, setSortOrder, setSortKey})
    }, [setSortKey, setSortOrder, sortOrder])

    return (
        <thead>
        <tr className="fw-bolder text-muted bg-light">
            {firstChildren}
            {
                headers.map(({key, label, className}, index) => (
                    <th key={index}
                        className={`${!index ? 'ps-5' : ''} ${className}`}>
                        <SortButton columnKey={key}
                                    onClick={() => handleClick(key)}
                                    label={label}
                                    sortOrder={sortOrder}
                                    sortKey={sortKey}
                        />
                    </th>
                ))
            }
            {children}
        </tr>
        </thead>
    )
}

export {THead}